module.exports = __webpack_public_path__ + "staticcomp/img/content_1.ad34b3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/9/content_1.jpg
// module id = MJY5
// module chunks = 39